import { render, staticRenderFns } from "./ratio.vue?vue&type=template&id=33edc3a1&scoped=true"
import script from "./ratio.vue?vue&type=script&lang=js"
export * from "./ratio.vue?vue&type=script&lang=js"
import style0 from "./ratio.vue?vue&type=style&index=0&id=33edc3a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33edc3a1",
  null
  
)

export default component.exports